module.exports = __webpack_public_path__ + "img/gorgeous-scheme.f5bff9b0.png";